import immutable from 'external/immutability-helper'
import {createPost} from 'utils/command'
import {useContext, useSelector, createSelector} from 'external/react'
import {toArray} from 'external/lodash'
import Homework from 'context/homework-context'
import uploadsStore from 'components/Uploads/redux/store'

const turnInStudentHomework = createPost('homework', 'saveStudentHomework')

const selectUploadFiles = createSelector(
  (state) => {
    return Object.values(state.UploadFile.fileProgress)
  },
  (files) => files.filter(f => !f.deleted && f.progress == 100).length
)

export default function useHomework () {
  const {state, update} = useContext(Homework.Context)
  const getStatus = id => state.statusMap[id]
  const [homeworksCount = {}, homeworks = []] = state.homeworks || []

  const files = useSelector(selectUploadFiles)

  async function saveHomework() {
    const files = toArray(uploadsStore.getState().UploadFile.fileProgress)
        .filter(f => !f.deleted && f.progress == 100)
        .map(file => { return {
            name: file.file.name,
            folder: file.folder
          }
        }) 
    const {id, properties: stateProperties} = state.homework
    const properties = immutable(stateProperties, {files: {$set: files}})
    const [homeworkSaved] = await turnInStudentHomework({id, properties, returned: true})
    if (homeworkSaved) {
      update({refreshHomework: {$apply: i => i + 1}})
    }
  }

  return {
    navigation: state.props.navigation,
    homework: state.homework,
    homeworkLoaded: state.homeworkLoaded,
    homeworks,
    homeworksCount,
    files,
    update,
    getStatus,
    saveHomework
  }
}
